module.exports = __webpack_public_path__ + "static/img/PC_IMG.fff0b33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mobile/Mobile_About_Us/PC_IMG.png
// module id = 6wgA
// module chunks = 0